import Alpine from "alpinejs";
window.Alpine = Alpine;
Alpine.start();

// --------- Filialen Carousel ----------
function initFilialenCarousel() {
  const wrapper = document.querySelector(".carousel-filialen");
  if (!wrapper) return;
  const items = Array.from(wrapper.querySelectorAll("a"));
  if (items.length < 2) return;

  // Clone all items and append them for seamless infinite scroll
  items.forEach((item) => {
    const clone = item.cloneNode(true);
    wrapper.appendChild(clone);
  });
  // Re-fetch items including clones
  const allItems = Array.from(wrapper.querySelectorAll("a"));

  let index = 1;
  let itemHeight = 0;
  let intervalId = null;
  let currentIndex = 0;

  // Helper to update transform and opacity
  function updateCarousel() {
    // Move the wrapper
    wrapper.style.transform = `translateY(-${index * itemHeight}px)`;
    // Update opacities: only active is 1, rest are faded
    allItems.forEach((el, i) => {
      el.style.transition = "opacity 0.5s";
      el.style.opacity = i === 2 ? "1" : "0.25";
    });
  }

  // Set height and start carousel
  function startCarouselAbout() {
    itemHeight = allItems[0]?.getBoundingClientRect().height || 0;
    if (itemHeight > 0) {
      // Set wrapper height for smoothness
      wrapper.parentElement.style.maxHeight = `${itemHeight * 3.1}px`;
      // Show the second item (index 1) initially
      wrapper.style.transform = `translateY(-${index * itemHeight}px)`;
      updateCarousel();
      intervalId = setInterval(() => {
        const nextItem =
          allItems[currentIndex % allItems.length].cloneNode(true);
        wrapper.appendChild(nextItem);

        wrapper.style.transition = "transform 0.6s ease-in-out";
        wrapper.style.transform = `translateY(-${itemHeight}px)`;

        const visible = wrapper.querySelectorAll("a");
        visible.forEach((el, i) => {
          el.style.transition = "opacity 0.5s ease-in-out";
          el.style.opacity = i === 2 ? "1" : "0.25";
        });

        setTimeout(() => {
          wrapper.style.transition = "none";
          wrapper.removeChild(wrapper.firstElementChild);
          wrapper.style.transform = "translateY(0)";
          currentIndex++;
        }, 600);
      }, 1800);
    } else {
      requestAnimationFrame(startCarouselAbout);
    }
  }
  startCarouselAbout();
  window.addEventListener("resize", () => {
    itemHeight = allItems[0]?.getBoundingClientRect().height || 0;
    updateCarousel();
  });
}
import Lenis from "lenis";
// Smooth scrolling
const lenis = new Lenis({
  lerp: 0.2,
  wheelMultiplier: 0.8,
  infinite: false,
  gestureOrientation: "vertical",
  normalizeWheel: false,
  syncTouch: false,
  autoRaf: true,
});

/// Add lenis prevent on iubenda Iframe ////
// Wait for iubenda button to exist before attaching click listener
const waitForIubendaButton = setInterval(() => {
  const iubendaBtn = document.querySelector(
    ".iubenda-tp-btn.iubenda-cs-preferences-link"
  );
  if (iubendaBtn) {
    clearInterval(waitForIubendaButton);
    iubendaBtn.addEventListener("click", () => {
      const observer = new MutationObserver((mutations, obs) => {
        const iframeDiv = document.getElementById("iubenda-iframe");
        if (iframeDiv) {
          iframeDiv.setAttribute("data-lenis-prevent", "");
          obs.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }
}, 500);

// select list icon
document.querySelectorAll("select").forEach((select) => {
  select.addEventListener("focus", () => {
    select.parentElement.classList.add("open");
  });
  select.addEventListener("blur", () => {
    select.parentElement.classList.remove("open");
  });
});

// normalise ul
document.querySelectorAll(".list-normalise ul").forEach((ul) => {
  ul.classList.add("normal");
});

// --------- What makes your day page ----------

function updateHeroTitleHeight() {
  const title = document.getElementById("hero-title");
  const headerNames = document.querySelector(".header-names");
  const heroDay = document.querySelector(".hero-day");

  if (headerNames && heroDay) {
    const waitForHeaderRender = () => {
      const headerHeight = headerNames.offsetHeight;
      const items = headerNames?.querySelectorAll(".header-name") || [];
      const heroCont = document.querySelector(".hero-day");
      if (headerHeight > 0) {
        requestIdleCallback(() => {
          if (heroCont && items.length >= 1) {
            const itemHeight = items[0].offsetHeight;
            heroCont.style.height = `${itemHeight * 7}px`;
          }
        });
      } else {
        requestAnimationFrame(waitForHeaderRender);
      }
    };

    requestAnimationFrame(waitForHeaderRender);
  }
}

function initCarouselScroll() {
  const wrapper = document.querySelector(".header-names");

  if (!wrapper) return;

  let items = wrapper.querySelectorAll(".header-name");

  // Clone all items and append them for a seamless scroll
  items.forEach((item) => {
    const clone = item.cloneNode(true);
    wrapper.appendChild(clone);
  });

  // Refresh items to include clones
  items = wrapper.querySelectorAll(".header-name");

  let index = 0;
  let isTransitioning = false;

  let itemHeight = 0;

  wrapper.style.transition = "transform 0.6s ease-in-out";
  wrapper.style.transform = "translateY(0)";

  const middleNameEl = document.getElementById("carousel-middle");

  // function getSuffix(name) {
  //   const vowels = ["a", "e", "i", "o", "u"];
  //   const lastChar = name.slice(-1).toLowerCase();
  //   return vowels.includes(lastChar) ? "'s" : "s";
  // }

  function updateItemOpacities(index) {
    if (!items.length) return;

    items.forEach((el) => {
      el.style.transition = "opacity 0.6s ease-in-out";
    });

    items.forEach((el, i) => {
      const position = (i - index + items.length) % items.length;

      let opacity = 1;
      switch (position) {
        case 0:
        case 6:
        case 7:
          opacity = 0.2;
          break;
        case 1:
        case 5:
          opacity = 0.4;
          break;
        case 2:
        case 4:
          opacity = 0.6;
          break;
        case 3:
          opacity = 0;
          break;
      }

      el.style.opacity = opacity;
    });
  }

  function updateMiddleName(index) {
    if (!middleNameEl || !items.length) return;
    const middleIndex = (index + 3) % items.length;
    const nameText =
      items[middleIndex]?.innerText?.trim().replace(/'s?$|s$/, "") || "";
    middleNameEl.innerText = nameText + "'s";
  }

  function measureAndStartCarousel() {
    itemHeight = items[0]?.getBoundingClientRect().height || 0;
    if (itemHeight > 0) {
      let maxWidth = 0;
      items.forEach((el) => {
        const anchor = el.querySelector("a");
        if (anchor) {
          const width = anchor.getBoundingClientRect().width;
          if (width > maxWidth) maxWidth = width;
        }
      });
      if (middleNameEl) {
        middleNameEl.style.display = "inline-block";
        middleNameEl.style.minWidth = `${Math.ceil(maxWidth)}px`;

        const middleBox = middleNameEl.getBoundingClientRect();
        const middleLeft = middleBox.left;

        items.forEach((item) => {
          const link = item.querySelector("a");
          if (link) {
            const itemBox = link.getBoundingClientRect();
            const offsetX = middleLeft - itemBox.left;
            link.style.transform = `translateX(${offsetX}px)`;
            link.style.display = "inline-block";
          }
        });

        const heroTitle = document.getElementById("hero-title");
        if (heroTitle) {
          heroTitle.style.minWidth = `${Math.ceil(maxWidth)}px`;
        }
      }

      updateMiddleName(index);
      updateItemOpacities(index);

      setInterval(() => {
        if (isTransitioning) return;
        isTransitioning = true;

        index++;
        const offset = index * itemHeight;
        wrapper.style.transition = "transform 0.6s ease-in-out";
        wrapper.style.transform = `translateY(-${offset}px)`;
        updateMiddleName(index);
        setTimeout(() => updateItemOpacities(index), 200);

        if (index >= items.length / 2) {
          setTimeout(() => {
            wrapper.style.transition = "none";
            wrapper.style.transform = "translateY(0)";
            index = 0;
            void wrapper.offsetWidth;
            wrapper.style.transition = "transform 1s ease-in-out";
            isTransitioning = false;
            updateMiddleName(index);
            updateItemOpacities(index);
          }, 1000);
        } else {
          setTimeout(() => {
            isTransitioning = false;
          }, 1000);
        }
      }, 1000);
    } else {
      requestAnimationFrame(measureAndStartCarousel);
    }
  }

  requestAnimationFrame(measureAndStartCarousel);

  window.addEventListener("resize", () => {
    itemHeight = items[0]?.getBoundingClientRect().height || 0;
    wrapper.style.transform = `translateY(-${index * itemHeight}px)`;
    updateMiddleName(index);
    updateItemOpacities(index);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  markRequiredPlaceholders();
  requestAnimationFrame(() => {
    setTimeout(updateHeroTitleHeight, 700);
    initCarouselScroll();
    initFilialenCarousel();
  });
  window.addEventListener("resize", updateHeroTitleHeight);
  initScrollRevealNav();
  // Keep spacing between nav and content correct
  syncMainMarginWithNav();
  // --------- What makes your day page ----------

  /// Mobile menu toggle ///
  const mobileToggle = document.getElementById("mobileMenuToggle");
  const mobileMenu = document.getElementById("mobileMenu");

  mobileToggle?.addEventListener("click", () => {
    const isOpen = !mobileMenu.classList.contains("translate-x-full");
    if (isOpen) {
      mobileMenu.classList.add("translate-x-full");
      mobileToggle.classList.remove("open");
      lenis.start(); // allow scrolling again
    } else {
      mobileMenu.classList.remove("translate-x-full");
      mobileToggle.classList.add("open");
      lenis.stop(); // prevent background scrolling
    }
  });
});
// --------- Swiper Video Pause on Slide Change ----------
document.addEventListener("DOMContentLoaded", function () {
  const prevBtn = document.querySelector(".swiper-button-prev");
  const nextBtn = document.querySelector(".swiper-button-next");

  function pausePlayingVideos() {
    const videos = document.querySelectorAll(".slider .swiper-slide video");
    videos.forEach((video) => {
      if (!video.paused) {
        video.pause();
      }
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", pausePlayingVideos);
  }
  if (nextBtn) {
    nextBtn.addEventListener("click", pausePlayingVideos);
  }
});
// --------- Swiper Video Pause on Slide Change ----------

function markRequiredPlaceholders() {
  const formElements = document.querySelectorAll(
    "input[required], textarea[required], select[required]"
  );

  formElements.forEach((el) => {
    if (el.tagName === "SELECT") {
      // For select elements, add * to the first option's text if not already present
      const firstOption = el.querySelector("option");
      if (firstOption && !firstOption.textContent.includes("*")) {
        firstOption.textContent += " *";
      }
    } else if (el.type === "checkbox" || el.type === "radio") {
      // For checkbox/radio, find the label associated via for attribute
      const id = el.id;
      if (id) {
        const label = document.querySelector(`label[for="${id}"]`);
        if (label && !label.textContent.includes("*")) {
          label.innerHTML = label.innerHTML.trim() + " *";
        }
      }
    } else {
      // For input/textarea with placeholder
      if (el.placeholder && !el.placeholder.includes("*")) {
        el.placeholder += " *";
      }
    }
  });
}

function initScrollRevealNav() {
  const nav = document.querySelector(".navigation");
  if (!nav) return;

  // Only toggle when the scroll delta is significant to avoid tiny momentum causing a hide on mobile
  const THRESHOLD = 6; // px of movement before we react

  let lastScroll = 0;

  // Ensure visible at load/top
  nav.classList.add("nav-visible");
  nav.classList.remove("nav-hidden");

  lenis.on("scroll", ({ scroll }) => {
    const delta = scroll - lastScroll;

    // Always show when at the very top
    if (scroll <= 0) {
      nav.classList.add("nav-visible");
      nav.classList.remove("nav-hidden");
      lastScroll = scroll;
      return;
    }

    // Ignore tiny deltas (mobile momentum / address bar resize etc.)
    if (Math.abs(delta) < THRESHOLD) {
      return;
    }

    if (delta < 0) {
      // Scrolling up -> reveal and keep it visible until a real scroll down happens
      nav.classList.add("nav-visible");
      nav.classList.remove("nav-hidden");
    } else {
      // Scrolling down -> hide
      nav.classList.remove("nav-visible");
      nav.classList.add("nav-hidden");
    }

    lastScroll = scroll;
  });
}

// Keep <main> top margin equal to nav height
function syncMainMarginWithNav() {
  const nav = document.querySelector(".navigation");
  const main = document.querySelector("main");
  if (!nav || !main) return;

  const apply = () => {
    const h = nav.getBoundingClientRect().height || 0;
    if (h > 0) {
      main.style.marginTop = `${h}px`;
    }
  };

  // Apply immediately
  apply();

  // Re-apply on nav size changes and window resizes
  if (typeof ResizeObserver !== "undefined") {
    const ro = new ResizeObserver(apply);
    ro.observe(nav);
  }

  window.addEventListener("resize", apply);
  nav.addEventListener("transitionend", apply);
}

import "./boxSizing.js";
import "./animations.js";
import "./sliders.js";
import "./fancybox.js";
import "./shares.js";
